<template>
  <div class="header">
      <div class="logo">
        <img v-if="isPc" src="../../assets/img/logo_OwnersBookPlus.svg" alt="">
        <img v-else src="../../assets/img/logo_OwnersBookPlus.svg" alt="">
        
      </div>
      <div class="step-content">
        <div class="step">
          <div  v-for="(item,index) in steps"  :key="index" :style="{'width': 100/steps.length+'%'}" :class="{'active':index == activeIndex,'pass-css': activeIndex > index}">
              <p class="title">STEP{{index+1}}</p>
          </div>
        </div>
        <div class="step">
          <div  v-for="(item,index) in steps" :key="index" :style="{'width': 100/steps.length+'%'}" :class="{'active':index == activeIndex,'pass-css': activeIndex > index}">
              <div class="circle"></div>
          </div>
          <div class="line-position">
            <p class="line" v-for="index of steps.length-1"  :key="index" :style="{'width': 100/(steps.length-1)+'%'}" :class="{'pass-line': activeIndex >= index}"></p>
          </div>
        </div>
        <div class="step">
          <div v-for="(item,index) in steps" :key="index" :style="{'width': 100/steps.length+'%'}" :class="{'active':index == activeIndex,'pass-css': activeIndex > index}">
              <div class="text" v-if="isPc">{{item.replace('\n','')}}</div>
              <div class="text" v-else v-html="item"></div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      steps:[
        'メール登録\n ',
        'お客様情報\nの入力',
        '書類提出と\nご本人確認',
        '口座開設\nお申込完了'
      ],
      isPc:false,
      activeIndex:0
    }
  },
  created(){
    
    this.initView()

    this.getActiveIndex() 
    
    window.addEventListener('resize',()=>{
      this.initView()
    })
  },
  watch: {
    $route(to, from) {
       this.getActiveIndex() 
    }
  },
  methods:{
    initView(){
      if(window.innerWidth >= 768) this.isPc = true
      else this.isPc = false
    },
    getActiveIndex(){
      
      let percent = this.commonJs.getTopTitle(this.$route.path).percentNum

      // 1 個人 2法人
      let type =  this.commonJs.getLocalData('applyTypeId') || 2

      this.activeIndex = 0
      
      if(percent > 0) this.activeIndex++
      if(type == 1){
        if(percent > 83) this.activeIndex++ // contentItem.js confirmInfo.percentNum: 83
      }else{
        if(percent > 77) this.activeIndex++ // contentItem.js corporateConfirmInfo.percentNum: 77,
      }
      if(percent == 100) this.activeIndex = this.steps.length -1 // contentItem.js 'Register/Over'.percentNum: 100,

    }
  }
}
</script>

<style lang="less" scoped>
.header{
  font-size: 20px;
  background-color: white;
}
.step-content{
  padding: 16px 10px;
}
.step{
  font-size: 14px;
  text-align: center;
  position: relative;
  .title{
    font-weight: bold;
  }
  .active{
    color: #00a4b0;
    .circle{
      background-color: #00a4b0;
    }
  }
  .circle{
    width: 16px;
    height: 16px;
    border-radius: 16px;
    border: 2px solid #00a4b0;
    margin-top: 4px;
    background-color: white;
    position: relative;
    z-index: 10;
    display: inline-block;
  }
  >div{
    display: inline-block;
  }
  .text{
    white-space: pre-wrap;
    line-height: 18px;
  }
  .line-position{
    width: 75%;
    position: absolute;
    left: 12.5%;
    top: 11px;
    .line{
      width: 33.3%;
      background-color: #00a4b0;
      height: 2px;
      float: left;
    }
    .pass-line{
      background-color: #868686;
    }
  }
  .pass-css{
    .title{
      color: #868686;
    }
    .text{
      color: #868686;
    }
    .circle{
      background-color: white;
      border-color: #868686;
      background-image: url(../../assets/icon/checked.svg);
      background-position: center;
      background-repeat: no-repeat;
      background-size: 8px;
    }
  }
}
.logo{
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  img{
    height: 25px;
    width: auto;
    max-width: 100%;
    display: block;
    object-fit: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/header.vue